<div class="spa-booking-status" [ngClass]="'spa-booking-status-' + status()">
  {{ status() }}
</div>
